import { AppHelper } from 'helpers/appHelper';
import { useRecoilState } from 'recoil';
import { AcctState } from 'stores/atoms/acctState';

/**
 *　ホーム画面 利用状況コンポーネント
 */
export default function WsIndexUsage(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 型定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const [acctState] = useRecoilState(AcctState);

  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <section className="section-statistical">
        <div className="container">
          <div className="row row-15-xl row-5-xl row-12-lg">
            <div className="col-md-3">
              <div className="card card-white">
                <div className="card-body">
                  <div className="d-flex d-flex-statistical">
                    <div className="flex-shrink-0 flex-left">
                      <small>参加数</small>
                      {AppHelper.formatNumberToCurrency(
                        acctState.usage.report.total.participatedCount
                      )}
                    </div>
                    <div className="flex-grow-1 flex-right">
                      <span className="img-body light-blue">
                        <img src="/img/icon/people.svg" alt="参加数" className="w-lg-26" />
                      </span>
                    </div>
                  </div>

                  {/* <p className="caption">
                    昨日より{" "}
                    <span className="icon-ani">
                      <img src="/img/icon/arrow-up.svg" alt="" />
                    </span>
                    <span className="text-blue number">8.5%</span>上昇
                  </p> */}
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="card card-white">
                <div className="card-body">
                  <div className="d-flex d-flex-statistical">
                    <div className="flex-shrink-0 flex-left">
                      <small>獲得リスト数</small>
                      {AppHelper.formatNumberToCurrency(
                        acctState.usage.report.total.mailAddressCount
                      )}
                    </div>
                    <div className="flex-grow-1 flex-right">
                      <span className="img-body light-yellow">
                        <img
                          src="/img/icon/arrow.svg"
                          alt="獲得リスト数 10293"
                          className="w-lg-26"
                        />
                      </span>
                    </div>
                  </div>

                  {/* <p className="caption">
                    先週より{" "}
                    <span className="icon-ani">
                      <img src="/img/icon/arrow-up.svg" alt="" />
                    </span>
                    <span className="text-blue number">1.3%</span>上昇
                  </p> */}
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="card card-white">
                <div className="card-body">
                  <div className="d-flex d-flex-statistical">
                    <div className="flex-shrink-0 flex-left">
                      <small>リスト獲得率</small>
                      {`${AppHelper.formatRateToPercent(
                        acctState.usage.report.total.mailAddressCount,
                        acctState.usage.report.total.participatedCount
                      )}%`}
                    </div>
                    <div className="flex-grow-1 flex-right">
                      <span className="img-body light-green">
                        <img src="/img/icon/chart.svg" alt="リスト獲得率 20%" className="w-lg-23" />
                      </span>
                    </div>
                  </div>

                  {/* <p className="caption">
                    昨日より{" "}
                    <span className="icon-ani">
                      <img src="/img/icon/arrow-down.svg" alt="" />
                    </span>
                    <span className="text-pink number">4.3%</span>下降
                  </p> */}
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="card card-white">
                <div className="card-body">
                  <div className="d-flex d-flex-statistical">
                    <div className="flex-shrink-0 flex-left">
                      <small>完了率</small>
                      {`${AppHelper.formatRateToPercent(
                        acctState.usage.report.total.answeredCount,
                        acctState.usage.report.total.participatedCount
                      )}%`}
                    </div>
                    <div className="flex-grow-1 flex-right">
                      <span className="img-body light-pink">
                        <img src="/img/icon/oclock.svg" alt="完了率 80%" className="w-lg-23" />
                      </span>
                    </div>
                  </div>

                  {/* <p className="caption">
                    昨日より{" "}
                    <span className="icon-ani">
                      <img src="/img/icon/arrow-up.svg" alt="" />
                    </span>
                    <span className="text-blue number">1.8%</span>上昇
                  </p> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
